import { Loader2 } from 'lucide-react';
import { Button, ButtonProps } from '~/components';
import { cn } from '~/style';

export const FormSubmitButton = ({
  label,
  className,
  variant,
  disabled,
  type,
  onClick,
  isLoading,
  size,
}: {
  label: string;
  className?: string;
  variant?: ButtonProps['variant'];
  disabled?: boolean;
  type?: ButtonProps['type'];
  onClick?: ButtonProps['onClick'];
  isLoading?: boolean;
  size?: ButtonProps['size'];
}) => {
  return (
    <div className="text-center">
      <Button
        className={cn('w-40 md:w-52', className)}
        variant={variant}
        type={type || 'submit'}
        onClick={onClick}
        disabled={disabled ?? isLoading}
        size={size}
      >
        {isLoading ? <Loader2 className="h-6 w-6 animate-spin" /> : label}
      </Button>
    </div>
  );
};
